module.exports = __webpack_public_path__ + "static/media/battery-mr-card-back.a8a2ceca.jpeg";